export const portfolioProjects = [
    {
      "id": "bitestreet",
      "title": "BiteStreet",
      "description": "App desenvolvido do zero, do planejamento à publicação nas lojas, para conectar clientes a barracas de comida de rua e butecos com localização em tempo real.",
      "longDescription": "A Codetime conduziu todo o desenvolvimento do BiteStreet, desde a concepção até a publicação nas lojas (App Store e Google Play). O app conecta usuários a vendedores de comida de rua e butecos próximos, com busca por categoria, GPS em tempo real para localizar as barracas, avaliações de clientes e chat direto entre cliente e vendedor para fechar o pedido.",
      "image": "/images/portfolio/bitestreet/cover.webp",
      "gallery": [
        "/images/portfolio/bitestreet/image_1.webp",
        "/images/portfolio/bitestreet/image_2.webp",
        "/images/portfolio/bitestreet/image_3.webp"
      ],
      "tags": [
        "Aplicativo Mobile",
        "Marketplace",
        "Geolocalização",
        "Chat em Tempo Real",
        "Publicação App Store e Google Play"
      ],
      "techDescription": "Aplicativo mobile desenvolvido do zero com busca e filtro por categoria, geolocalização em tempo real dos vendedores, sistema de avaliações e chat direto entre cliente e fornecedor, publicado nas lojas Apple e Google.",
      "features": [
        "Busca de vendedores por categoria (comida de rua, buteco, tipo de comida)",
        "Mapa com localização em tempo real das barracas e butecos",
        "Avaliações e notas dos clientes",
        "Chat direto entre cliente e vendedor para fechar o pedido",
        "Cadastro de fornecedores e cardápios",
        "Publicação e manutenção nas lojas Apple e Google"
      ],
      "client": "BiteStreet",
      "duration": "Desenvolvido do zero",
      "category": "Aplicativo Mobile",
      "results": [
        "App publicado nas lojas Apple e Google",
        "Conexão direta entre clientes e vendedores de rua via chat e geolocalização"
      ],
      "status": "Em andamento",
      "link": "https://bitestreet.com.br/"
    },
    {
      "id": "lebasi",
      "title": "Lebasi",
      "description": "Sistema sob medida para gestão de ILPIs (Instituições de Longa Permanência para Idosos), unificando gestão financeira, cobranças, controle de gastos, visitas e medicação.",
      "longDescription": "Sistema desenvolvido para a Rede Lebasi, rede de residenciais sênior, para centralizar a operação administrativa e assistencial de suas unidades. A plataforma organiza a gestão financeira e o controle de gastos, automatiza a geração de cobranças recorrentes aos residentes e familiares, e dá suporte à rotina de cuidado com controle de visitas e controle de medicação dos residentes.",
      "image": "/images/portfolio/lebasi/cover.webp",
      "gallery": [
        "/images/portfolio/lebasi/cover.webp",
        "/images/portfolio/lebasi/image_1.webp"
      ],
      "tags": [
        "Gestão de ILPI",
        "Gestão Financeira",
        "Cobranças",
        "Controle de Visitas",
        "Controle de Medicação"
      ],
      "techDescription": "Sistema sob medida para gestão de instituições de longa permanência para idosos, com módulos de financeiro, cobrança automatizada, controle de gastos e rotinas assistenciais (visitas e medicação).",
      "features": [
        "Gestão financeira e controle de gastos das unidades",
        "Geração automatizada de cobranças a residentes e responsáveis",
        "Controle de visitas aos residentes",
        "Controle de medicação e rotinas assistenciais",
        "Visão consolidada da operação para múltiplas unidades"
      ],
      "client": "Rede Lebasi",
      "duration": "Inicio em 2026",
      "category": "Sistema Sob Medida",
      "results": [
        "Centralização da gestão financeira e de cobranças",
        "Maior controle e rastreabilidade das visitas e da medicação dos residentes"
      ],
      "status": "Em andamento",
      "link": "https://redelebasi.com.br/"
    },
    {
      "id": "healthby",
      "title": "Healthby AI",
      "description": "Plataforma que transcreve consultas e estrutura informações clínicas; gera documentos e integra com Memed e prontuário.",
      "longDescription": "Sistema para Clínica de Saúde, durante a consulta, o sistema transcreve o áudio e auxilia o médico na elaboração da anamnese e hipóteses. Gera laudos, receitas e relatórios, com prescrição via Memed (assinatura digital) e integração ao prontuário eletrônico. Envio de documentos por WhatsApp corporativo.",
      "image": "/images/portfolio/health/image_capa2.webp",
      "gallery": [
        "/images/portfolio/health/imagem_3.webp",
        "/images/portfolio/health/imagem_1.webp",
        "/images/portfolio/health/imagem_2.webp"
      ],
      "tags": [
        "IA em saúde",
        "Reconhecimento de voz",
        "PLN",
        "Integração WhatsApp",
        "Memed"
      ],
      "techDescription": "Reconhecimento de voz + NLP para transcrição e estruturação; leitura de PDFs; geração de documentos; integrações REST (Memed, prontuário).",
      "features": [
        "Transcrição automática da consulta",
        "Estruturação assistida de anamnese e hipóteses",
        "Laudos, receitas e relatórios em 1 clique",
        "Prescrições via Memed com assinatura digital",
        "Leitura de exames em PDF",
        "Integração com prontuário eletrônico",
        "Envio de documentos via WhatsApp corporativo"
      ],
      "client": "Healthby AI",
      "duration": "6 meses",
      "category": "Sistema Sob Medida",
      "results": [
        "-40% no tempo de registro por atendimento",
        "+25% produtividade da agenda",
        "Redução de retrabalho em documentos"
      ],
      "compliance": [
        "Consentimento do paciente",
        "Criptografia em trânsito e repouso",
        "Controle de acesso por perfil",
        "Decisão clínica é do médico (apoio à decisão)"
      ],
      "link": "https://healthby.ai/"
    },
    {
      "id": "jobclin",
      "title": "Jobclin",
      "description": "Plataforma de gestão clínica que passou a ser atendida pela Codetime recentemente, com foco em manutenção, suporte e evolução contínua.",
      "longDescription": "Sistema para Laboratório de Saúde, a Codetime assumiu a responsabilidade técnica em 2025, garantindo continuidade operacional e iniciando um plano de evolução. Nosso trabalho envolve manutenção corretiva, atualizações de segurança e desenvolvimento de novas funcionalidades estratégicas para o setor de saúde digital.",
      "image": "/images/portfolio/jobclin/cover.webp",
      "gallery": [
        "/images/portfolio/jobclin/image_1.webp",
        "/images/portfolio/jobclin/image_2.webp",
        "/images/portfolio/jobclin/image_3.webp"
      ],
      "tags": [
        "Saúde Digital",
        "Prontuário Eletrônico",
        "Telemedicina",
        "Integrações",
        "Segurança"
      ],
      "techDescription": "Estamos conduzindo a manutenção e evolução tecnológica do Jobclin, com foco em estabilidade, escalabilidade e novas integrações necessárias para o mercado de saúde. O objetivo é fortalecer a base do sistema e agregar novas funcionalidades que ampliem sua competitividade.",
      "features": [
        "Manutenção e estabilização do sistema existente",
        "Aprimoramento do prontuário eletrônico",
        "Integrações com sistemas de prescrição e exames",
        "Suporte a telemedicina e agendamento online",
        "Ajustes de performance e segurança",
        "Roadmap de evolução contínua em conjunto com o cliente"
      ],
      "client": "Jobclin",
      "duration": "Inicio em 2025",
      "category": "Manutenção e Evolução de Sistema",
      "results": [
        "Continuidade operacional garantida desde a transição",
        "Primeiras melhorias de performance já entregues",
        "Plano em andamento para expansão de funcionalidades"
      ],
      "status": "Em andamento",
      "link": "https://www.jobclin.com.br/"
    },
    {
      "id": "gestortop",
      "title": "GestorTop",
      "description": "Sistema de gestão administrativa, cuja manutenção e evolução passaram a ser responsabilidade da Codetime, incluindo integrações complexas e novos módulos.",
      "longDescription": "Sistema de gestão para Supermercados, Padaria, Restaurante e Outros, a Codetime assumiu a responsabilidade técnica em 2023, garantindo continuidade operacional e iniciando um plano de evolução. Nosso trabalho envolve manutenção corretiva, atualizações de segurança e desenvolvimento de novas funcionalidades estratégicas para o setor de supermercados.",
      "image": "/images/portfolio/gestortop/image.webp",
      "gallery": [
        "/images/portfolio/gestortop/image_2.webp",
        "/images/portfolio/gestortop/image_3.webp"
      ],
      "tags": [
        "Manutenção de Sistemas",
        "Integrações com Hardware",
        "Pagamentos",
        "Fisco Digital",
        "E-commerce"
      ],
      "techDescription": "Assumimos a gestão técnica do sistema, implementando melhorias de performance, segurança e novas funcionalidades sob demanda. Entre os marcos estão integrações com dispositivos físicos, meios de pagamento e sistemas fiscais, ampliando significativamente o alcance do software.",
      "features": [
        "Integração com balança física via comunicação serial",
        "Criação de totem de autoatendimento",
        "Integração com TEF (Transferência Eletrônica de Fundos) e SmartPOS",
        "Emissão de Nota Fiscal e Cupom Fiscal",
        "Integração bancária para conciliação automática",
        "Integração com plataformas de e-commerce e marketplaces",
        "Correções de bugs e evolução contínua"
      ],
      "client": "GestorTop",
      "duration": "Inicio em 2023",
      "category": "Manutenção e Evolução de Sistema",
      "results": [
        "Sistema mais robusto e preparado para diferentes frentes de operação",
        "Redução de falhas e retrabalhos com integrações fiscais e bancárias",
        "Melhoria na experiência do usuário com autoatendimento e novos fluxos digitais"
      ],
      "status": "Cliente ativo",
      "link": "https://gestortop.com.br/"
    },
    {
      "id": "g6cred",
      "title": "G6Cred",
      "description": "Evolução contínua do site institucional com fluxo completo de autoagendamento, follow up automático via WhatsApp e integração funcional com o CRM RD Station.",
      "longDescription": "A Codetime assumiu a manutenção e evolução do site que a G6Cred já possuía, conduzindo upgrades constantes na plataforma. Implementamos um fluxo de autoagendamento para os leads, com follow up automático via WhatsApp para aumentar a taxa de conversão e reduzir o trabalho manual da equipe comercial. Também corrigimos e reintegramos o CRM RD Station, que não estava funcionando corretamente, garantindo o fluxo correto de leads entre site e CRM.",
      "image": "/images/portfolio/g6cred/cover.webp",
      "gallery": [
        "/images/portfolio/g6cred/image_2.webp",
        "/images/portfolio/g6cred/image_3.webp"
      ],
      "tags": [
        "Autoagendamento",
        "Automação WhatsApp",
        "Integração CRM",
        "RD Station",
        "Evolução Contínua"
      ],
      "features": [
        "Fluxo de autoagendamento direto pelo site",
        "Follow up automático via WhatsApp para leads",
        "Integração funcional com o CRM RD Station",
        "Manutenção evolutiva contínua da plataforma"
      ],
      "techDescription": "Evolução de site institucional existente; automação de fluxo de agendamento e follow up via API de WhatsApp; integração REST com RD Station CRM.",
      "client": "G6Cred",
      "duration": "Projeto contínuo",
      "category": "Evolução de Sistema",
      "results": [
        "Redução do trabalho manual de follow up comercial",
        "Fluxo de leads corrigido entre site e CRM",
        "Mais agilidade no agendamento pelo próprio lead"
      ],
      "compliance": [
        "Boas práticas de segurança da informação e LGPD (dados de leads)",
        "Política de privacidade e cookies publicada no site do produto"
      ],
      "status": "Cliente ativo",
      "link": "https://g6cred.com.br/"
    },
    {
      "id": "portal-dos-cegonheiros",
      "title": "Portal dos Cegonheiros",
      "description": "App completo desenvolvido do zero para motoristas cegonheiros gerenciarem os custos do caminhão: leitura de abastecimento por IA, manutenções, troca de pneus, alertas de combustível na rota e relatórios de economia para os gestores.",
      "longDescription": "A Codetime desenvolveu o aplicativo do Portal dos Cegonheiros desde a concepção, publicado nas lojas Apple e Google. É um app completo para o motorista gerenciar todos os custos do caminhão: o reconhecimento de IA lê os dados da Nota Fiscal automaticamente, facilitando o registro do abastecimento; o app também registra manutenções e trocas de pneus, calcula o preço de combustível da viagem e alerta o motorista sobre postos com melhores preços ao longo da rota. Além disso, envia relatórios semanais aos gestores com as possíveis economias identificadas. Toda a operação é integrada ao ERP nativo da empresa, unificando dados de frota, abastecimento, manutenção e documentação fiscal em um único fluxo.",
      "image": "/images/portfolio/portalcegonheiros/cover.webp",
      "gallery": [
        "/images/portfolio/portalcegonheiros/image_2.webp",
        "/images/portfolio/portalcegonheiros/image_3.webp"
      ],
      "tags": [
        "Aplicativo Mobile",
        "IA em Documentos",
        "Leitura de NF",
        "Gestão de Manutenção",
        "Logística",
        "Integração ERP",
        "Publicação App Store e Google Play"
      ],
      "features": [
        "Reconhecimento de IA para leitura automática de dados de Notas Fiscais no abastecimento",
        "Registro de manutenções e trocas de pneus",
        "Cálculo de preço de combustível da viagem",
        "Alertas de postos com melhores preços ao longo da rota",
        "Relatórios semanais de economia para os gestores dos motoristas",
        "Integração com o ERP nativo da empresa",
        "Publicação e manutenção nas lojas Apple e Google"
      ],
      "techDescription": "Aplicativo mobile nativo/híbrido com reconhecimento de imagem e IA para extração de dados de NF; controle de manutenções e pneus; cálculo de rota e precificação de combustível; geração de relatórios gerenciais; integração REST com o ERP da empresa.",
      "client": "Portal dos Cegonheiros",
      "duration": "Desenvolvido do zero",
      "category": "Aplicativo Mobile",
      "results": [
        "Automação da leitura e lançamento de Notas Fiscais no abastecimento",
        "Redução de custo de combustível com alertas de melhores preços na rota",
        "Visibilidade gerencial de economia semanal por motorista",
        "Operação unificada com o ERP nativo da empresa"
      ],
      "compliance": [
        "Boas práticas de segurança da informação e LGPD (dados de motoristas)",
        "Publicado e mantido segundo as políticas da App Store e Google Play"
      ],
      "status": "Cliente ativo",
      "link": "https://www.portaldoscegonheiros.com.br/"
    },
    {
      "id": "llp-consultoria",
      "title": "LLP Consultoria",
      "description": "ERP para prestadores de serviços com foco inicial em Odontologia: conciliação bancária, contas a pagar/receber, precificação, CRM e controle de leads.",
      "longDescription": "A LLP Consultoria decidiu oferecer um sistema próprio de gestão aos seus clientes. A Codetime desenvolve um ERP voltado a prestadores de serviços, com ênfase em clínicas odontológicas, contemplando financeiro (conciliação, contas a pagar/receber), precificação por procedimentos, CRM e funil de leads. O objetivo é centralizar operação e finanças em um único ambiente, simplificando o dia a dia e aumentando previsibilidade de caixa.",
      // "image": "/images/portfolio/llp/cover.webp",
      "image": "/images/portfolio/llp/image_1.webp",
      "gallery": [
        // "/images/portfolio/llp/image_1.webp",
        "/images/portfolio/llp/cover.webp",
        "/images/portfolio/llp/image_2.webp",
        "/images/portfolio/llp/image_3.webp",
        "/images/portfolio/llp/image_4.webp"
      ],
      "tags": [
        "ERP",
        "Serviços",
        "Odontologia",
        "Conciliação Bancária",
        "Financeiro",
        "CRM",
        "Leads"
      ],
      "techDescription": "Arquitetura web modular (API-first) com módulos de financeiro e comercial. Conciliação bancária por importação de extratos (OFX/CSV), regras de categorização, centro de custos e controle de recebíveis. CRM com etapas de funil e registro de atividades. Camadas de autorização por perfil e segregação de dados por empresa.",
      "features": [
        "Conciliação bancária com importação de extratos e categorização",
        "Contas a pagar e receber com projeção de fluxo de caixa",
        "Precificação por procedimento/serviço (tabelas personalizáveis)",
        "CRM e funil de leads com tarefas e histórico de contato",
        "Cadastro de clientes, profissionais e unidades",
        "Centros de custos e relatórios gerenciais",
        "Perfis de acesso e segregação por CNPJ/unidade"
      ],
      "client": "LLP Consultoria",
      "duration": "3 meses",
      "status": "Em andamento",
      "category": "Sistema Sob Medida",
      "results": [
        "Operação financeira e comercial centralizadas em uma única plataforma",
        "Fechamento financeiro mais previsível com apoio da conciliação",
        "Melhor acompanhamento do funil de vendas e dos retornos de leads"
      ],
      "compliance": [
        "LGPD: controle de acesso por perfil e segregação de dados por empresa",
        "Criptografia em trânsito, revisão periódica de permissões",
        "Trilhas de auditoria para operações sensíveis (financeiro)"
      ],
      "link": "https://llpconsultoria.app.br/login"
    },
    {
      "id": "avelar-saude",
      "title": "Avelar Saúde",
      "description": "Plataforma única para substituir 3 sistemas legados (funerária, clínica e seguradora de saúde), centralizando gestão e reduzindo complexidade operacional.",
      "longDescription": "Sistema para Funerária, Clínica e Seguradora de Saúde, a Codetime assumiu a responsabilidade técnica em 2022, garantindo continuidade operacional e iniciando um plano de evolução. Nosso trabalho envolve manutenção corretiva, atualizações de segurança e desenvolvimento de novas funcionalidades estratégicas para o setor de saúde.",
      "image": "/images/portfolio/avelar/cover.webp",
      "gallery": [
        // "/images/portfolio/avelar/screen-1.webp",
        // "/images/portfolio/avelar/screen-2.webp",
        // "/images/portfolio/avelar/screen-3.webp"
      ],
      "tags": [
        "ERP",
        "Saúde",
        "Seguradora",
        "Clínica",
        "Funerária",
        "Integração de Sistemas"
      ],
      "techDescription": "Sistema ERP modular com camadas específicas para clínica, funerária e seguradora, construído em arquitetura web escalável. Inclui módulo financeiro (contas a pagar/receber, fluxo de caixa), gestão de contratos, agendamento de atendimentos, emissão de documentos fiscais e relatórios unificados. API aberta para integrações futuras.",
      "features": [
        "Unificação de três sistemas legados em uma plataforma única",
        "Módulo financeiro completo com projeção de caixa",
        "Gestão de contratos de saúde e seguros",
        "Agendamento de consultas e serviços",
        "Emissão de notas fiscais e documentos automatizados",
        "Relatórios integrados para diretoria",
        "API para integrações externas"
      ],
      "client": "Avelar Saúde",
      "duration": "12 meses",
      "status": "Concluído",
      "category": "Sistema Sob Medida",
      "results": [
        "Redução de custos operacionais com eliminação de 3 sistemas",
        "Maior eficiência no controle financeiro e de contratos",
        "Processos unificados e melhor experiência para clientes e equipe"
      ],
      "compliance": [
        "LGPD: segregação de dados por unidade e cliente",
        "Controle de acesso por perfis",
        "Registro de logs e trilhas de auditoria"
      ],
      "link": "https://avelarsaude.com.br/cartaoavelarsaude/"
    }
];

export const getProjectById = (id) => {
  return portfolioProjects.find(project => project.id === id);
};

export const getAllProjects = () => {
  return portfolioProjects;
}; 